export default __webpack_public_path__ + "static/media/hide.e6886d95.svg";